import React, { useEffect } from 'react';
import Bloom from '../components/Bloom';
import Orbit from '../components/Orbit';
import MainMenu from '../components/MainMenu';
import '../styles/Home.css';
 


const HomePage = () => {
  useEffect(() => {
    // Disable scrolling
    document.body.style.overflow = 'hidden';

    // Cleanup function to re-enable scrolling when the component unmounts
    return () => {
      document.body.style.overflow = 'auto';
    };
  }, []);
  
  return (

    <div className="home-page">
       <MainMenu />
      
      <div>
       <Orbit/>
      {/* <Bloom/> */}
      </div>
      <div
        style={{
          position: 'absolute',
          bottom: '50px',
          left: '50px',
          color: 'white',
          fontSize: '30px',
          fontWeight: 10
    
        }}
      >
        <div className = "home-text">
        <a 
      href="/projects/orbit" 
      rel="noopener noreferrer"
      style={{ color: 'white', textDecoration: 'none' }}
    >
      orbit (2020)
    </a>

        </div>
      </div>
    </div>
  );

}


export default HomePage;
